import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationsApi } from '@/api/endpoints/notifications';
import type { NotificationInput } from '@/api/endpoints/notifications';

export const useNotificationsList = () =>
  useQuery({
    queryKey: ['notifications'],
    queryFn: notificationsApi.list,
    staleTime: 1000 * 30,
    retry: 1,
  });

export const useCreateNotification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: NotificationInput) => notificationsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
};

export const useDispatchNotification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationsApi.dispatch(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
};

export const useDeleteNotification = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => notificationsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
};

export const useDeviceInsights = () =>
  useQuery({
    queryKey: ['notifications', 'device-insights'],
    queryFn: notificationsApi.deviceInsights,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
